import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({
	Welcome: {
		k: "welcome",
		v: "Welcome Back, ${user}",
		argNames: ["user", "firstName", "lastName"],
		allowMarkdown: true,
		type: "MARKDOWN"
	},

	LastLogin: {
		k: "lastLogin",
		v: "Last Login: ${date}",
		argNames: ["date"]
	},

	Certificates: {
		k: "certificatesEarned",
		v: "${count} Certificates Earned",
		argNames: ["count"]
	},

	LastLaunched: {
		k: "lastLaunched.continue",
		v: "Continue Last Lesson"
	},
	TotalCredits: {
		k: "totalCredits",
		v: "${totalcredits} Credits",
		argNames: ["totalcredits"]
	}
});



// WEBPACK FOOTER //
// ./src/panels/userSummary/UserSummary.labels.ts